import { InjectionToken } from '@angular/core';

/**
 * End-to-end file encryption (core/vault) is switched off. Its key was derived from the account
 * password typed at sign-in, and sign-in now goes through SSO, so the browser never sees a
 * password. The code is kept: turning this back on also needs a passphrase the user types, and
 * FILE_ENCRYPTION_ENABLED in backend/app.ts.
 */
export const FILE_ENCRYPTION_ENABLED = false;

/** FILE_ENCRYPTION_ENABLED, injectable so the kept vault code can still be tested. */
export const FILE_ENCRYPTION = new InjectionToken<boolean>('FILE_ENCRYPTION', {
  factory: () => FILE_ENCRYPTION_ENABLED,
});

// Injected at build time by scripts/ng-with-env.mjs (`--define`) from the deployment's
// AUTH_METHODS (sst.config.ts): "saml", "password" or "saml,password". Absent in unit tests.
declare const AUTH_METHODS: string | undefined;

const authMethods = (typeof AUTH_METHODS === 'undefined' ? 'saml' : AUTH_METHODS)
  .split(',')
  .map((method) => method.trim().toLowerCase());

/**
 * Sign-in through the company identity provider via the Cognito hosted UI. SSO_PROVIDER is the
 * name of the SAML provider in the user pool (sst.config.ts).
 */
export const SSO_SIGN_IN_ENABLED = authMethods.includes('saml');
export const SSO_PROVIDER = 'EntraID';

/**
 * The email + password + TOTP sign-in (features/login: sign-in, set-password, two-factor). The
 * pool client then also allows ALLOW_USER_SRP_AUTH (sst.config.ts).
 */
export const PASSWORD_SIGN_IN_ENABLED = authMethods.includes('password');
